import StudentHeader from "../common/StudentHeader";
import Swal from "sweetalert2";

const StudentPersonalDetailsLandingPage = () => {


  Swal.fire({
    title: `Hi! ${localStorage.getItem("loggedUserFullName")} 👋`,
    text: "Have a wonderful day!",
    icon: "success",
    timer: 5000,
    showConfirmButton: false,
  });


  return (
    <>
      <StudentHeader />
      <div className="container mt-5">
        <div>Stduent Dashboard</div>
      </div>
    </>
  );
};

export default StudentPersonalDetailsLandingPage;
